const messages = [
  {
    username: "FirstMessage",
    avatarUrl:
      "https://avatars0.githubusercontent.com/u/32957606?s=460&u=e631c3762c12d41f3ce0348b8137f0751a2eed75&v=4",
    timestamp: "Today at 17:42",
    message: "Hello! how are you?",
  },
  {
    username: "Cyberpunk 1850",
    avatarUrl:
      "https://static1.colliderimages.com/wordpress/wp-content/uploads/2020/11/cyberpunk-2077-social.jpg",
    timestamp: "Today at 17:42",
    message: "Hey u ready to roll?",
  },
  {
    username: "Imgi",
    avatarUrl: "https://i.imgur.com/cwNLYtg.png",
    timestamp: "Today at 17:42",
    message: "Sup sup sup sup!",
  },
  {
    username: "Brod",
    avatarUrl:
      "https://www.biography.com/.image/c_fill%2Ccs_srgb%2Cfl_progressive%2Ch_400%2Cq_auto:good%2Cw_620/MTY2MzU3Nzk2OTM2MjMwNTkx/elon_musk_royal_society.jpg",
    timestamp: "Today at 17:42",
    message: "Got room for 1 more?",
  },
  {
    username: "FirstMessage",
    avatarUrl:
      "https://avatars0.githubusercontent.com/u/32957606?s=460&u=e631c3762c12d41f3ce0348b8137f0751a2eed75&v=4",
    timestamp: "Today at 17:42",
    message: "Hello! how are you?",
  },
  {
    username: "Cyberpunk 1850",
    avatarUrl:
      "https://static1.colliderimages.com/wordpress/wp-content/uploads/2020/11/cyberpunk-2077-social.jpg",
    timestamp: "Today at 17:42",
    message: "Hey u ready to roll?",
  },
  {
    username: "Imgi",
    avatarUrl: "https://i.imgur.com/cwNLYtg.png",
    timestamp: "Today at 17:42",
    message: "Sup sup sup sup!",
  },
  {
    username: "Brod",
    avatarUrl:
      "https://www.biography.com/.image/c_fill%2Ccs_srgb%2Cfl_progressive%2Ch_400%2Cq_auto:good%2Cw_620/MTY2MzU3Nzk2OTM2MjMwNTkx/elon_musk_royal_society.jpg",
    timestamp: "Today at 17:42",
    message: "Got room for 1 more?",
  },
  {
    username: "FirstMessage",
    avatarUrl:
      "https://avatars0.githubusercontent.com/u/32957606?s=460&u=e631c3762c12d41f3ce0348b8137f0751a2eed75&v=4",
    timestamp: "Today at 17:42",
    message: "Hello! how are you?",
  },
  {
    username: "Cyberpunk 1850",
    avatarUrl:
      "https://static1.colliderimages.com/wordpress/wp-content/uploads/2020/11/cyberpunk-2077-social.jpg",
    timestamp: "Today at 17:42",
    message: "Hey u ready to roll?",
  },
  {
    username: "Imgi",
    avatarUrl: "https://i.imgur.com/cwNLYtg.png",
    timestamp: "Today at 17:42",
    message: "Sup sup sup sup!",
  },
  {
    username: "Brod",
    avatarUrl:
      "https://www.biography.com/.image/c_fill%2Ccs_srgb%2Cfl_progressive%2Ch_400%2Cq_auto:good%2Cw_620/MTY2MzU3Nzk2OTM2MjMwNTkx/elon_musk_royal_society.jpg",
    timestamp: "Today at 17:42",
    message: "Got room for 1 more?",
  },
  {
    username: "Cyberpunk 1850",
    avatarUrl:
      "https://static1.colliderimages.com/wordpress/wp-content/uploads/2020/11/cyberpunk-2077-social.jpg",
    timestamp: "Today at 17:42",
    message: "Hey u ready to roll?",
  },
  {
    username: "Imgi",
    avatarUrl: "https://i.imgur.com/cwNLYtg.png",
    timestamp: "Today at 17:42",
    message: "Sup sup sup sup!",
  },
  {
    username: "Brod",
    avatarUrl:
      "https://www.biography.com/.image/c_fill%2Ccs_srgb%2Cfl_progressive%2Ch_400%2Cq_auto:good%2Cw_620/MTY2MzU3Nzk2OTM2MjMwNTkx/elon_musk_royal_society.jpg",
    timestamp: "Today at 17:42",
    message: "Got room for 1 more?",
  },
  {
    username: "Cyberpunk 1850",
    avatarUrl:
      "https://static1.colliderimages.com/wordpress/wp-content/uploads/2020/11/cyberpunk-2077-social.jpg",
    timestamp: "Today at 17:42",
    message: "Hey u ready to roll?",
  },
  {
    username: "Imgi",
    avatarUrl: "https://i.imgur.com/cwNLYtg.png",
    timestamp: "Today at 17:42",
    message: "Sup sup sup sup!",
  },
  {
    username: "Brod",
    avatarUrl:
      "https://www.biography.com/.image/c_fill%2Ccs_srgb%2Cfl_progressive%2Ch_400%2Cq_auto:good%2Cw_620/MTY2MzU3Nzk2OTM2MjMwNTkx/elon_musk_royal_society.jpg",
    timestamp: "Today at 17:42",
    message: "Got room for 1 more?",
  },
  {
    username: "Cyberpunk 1850",
    avatarUrl:
      "https://static1.colliderimages.com/wordpress/wp-content/uploads/2020/11/cyberpunk-2077-social.jpg",
    timestamp: "Today at 17:42",
    message: "Hey u ready to roll?",
  },
  {
    username: "Imgi",
    avatarUrl: "https://i.imgur.com/cwNLYtg.png",
    timestamp: "Today at 17:42",
    message: "Sup sup sup sup!",
  },
  {
    username: "Brod",
    avatarUrl:
      "https://www.biography.com/.image/c_fill%2Ccs_srgb%2Cfl_progressive%2Ch_400%2Cq_auto:good%2Cw_620/MTY2MzU3Nzk2OTM2MjMwNTkx/elon_musk_royal_society.jpg",
    timestamp: "Today at 17:42",
    message: "Got room for 1 more?",
  },
  {
    username: "Cyberpunk 1850",
    avatarUrl:
      "https://static1.colliderimages.com/wordpress/wp-content/uploads/2020/11/cyberpunk-2077-social.jpg",
    timestamp: "Today at 17:42",
    message: "Hey u ready to roll?",
  },
  {
    username: "Imgi",
    avatarUrl: "https://i.imgur.com/cwNLYtg.png",
    timestamp: "Today at 17:42",
    message: "Sup sup sup sup!",
  },
  {
    username: "Brod",
    avatarUrl:
      "https://www.biography.com/.image/c_fill%2Ccs_srgb%2Cfl_progressive%2Ch_400%2Cq_auto:good%2Cw_620/MTY2MzU3Nzk2OTM2MjMwNTkx/elon_musk_royal_society.jpg",
    timestamp: "Today at 17:42",
    message: "Got room for 1 more?",
  },
  {
    username: "FirstMessage",
    avatarUrl:
      "https://avatars0.githubusercontent.com/u/32957606?s=460&u=e631c3762c12d41f3ce0348b8137f0751a2eed75&v=4",
    timestamp: "Today at 17:42",
    message: "Hello! how are you?",
  },
  {
    username: "Cyberpunk 1850",
    avatarUrl:
      "https://static1.colliderimages.com/wordpress/wp-content/uploads/2020/11/cyberpunk-2077-social.jpg",
    timestamp: "Today at 17:42",
    message: "Hey u ready to roll?",
  },
  {
    username: "Imgi",
    avatarUrl: "https://i.imgur.com/cwNLYtg.png",
    timestamp: "Today at 17:42",
    message: "Sup sup sup sup!",
  },
  {
    username: "Brod",
    avatarUrl:
      "https://www.biography.com/.image/c_fill%2Ccs_srgb%2Cfl_progressive%2Ch_400%2Cq_auto:good%2Cw_620/MTY2MzU3Nzk2OTM2MjMwNTkx/elon_musk_royal_society.jpg",
    timestamp: "Today at 17:42",
    message: "Got room for 1 more?",
  },
  {
    username: "FirstMessage",
    avatarUrl:
      "https://avatars0.githubusercontent.com/u/32957606?s=460&u=e631c3762c12d41f3ce0348b8137f0751a2eed75&v=4",
    timestamp: "Today at 17:42",
    message: "Hello! how are you?",
  },
  {
    username: "Cyberpunk 1850",
    avatarUrl:
      "https://static1.colliderimages.com/wordpress/wp-content/uploads/2020/11/cyberpunk-2077-social.jpg",
    timestamp: "Today at 17:42",
    message: "Hey u ready to roll?",
  },
  {
    username: "Imgi",
    avatarUrl: "https://i.imgur.com/cwNLYtg.png",
    timestamp: "Today at 17:42",
    message: "Sup sup sup sup!",
  },
  {
    username: "Brod",
    avatarUrl:
      "https://www.biography.com/.image/c_fill%2Ccs_srgb%2Cfl_progressive%2Ch_400%2Cq_auto:good%2Cw_620/MTY2MzU3Nzk2OTM2MjMwNTkx/elon_musk_royal_society.jpg",
    timestamp: "Today at 17:42",
    message: "Got room for 1 more?",
  },
  {
    username: "Cyberpunk 1850",
    avatarUrl:
      "https://static1.colliderimages.com/wordpress/wp-content/uploads/2020/11/cyberpunk-2077-social.jpg",
    timestamp: "Today at 17:42",
    message: "Hey u ready to roll?",
  },
  {
    username: "Imgi",
    avatarUrl: "https://i.imgur.com/cwNLYtg.png",
    timestamp: "Today at 17:42",
    message: "Sup sup sup sup!",
  },
  {
    username: "Brod",
    avatarUrl:
      "https://www.biography.com/.image/c_fill%2Ccs_srgb%2Cfl_progressive%2Ch_400%2Cq_auto:good%2Cw_620/MTY2MzU3Nzk2OTM2MjMwNTkx/elon_musk_royal_society.jpg",
    timestamp: "Today at 17:42",
    message: "Got room for 1 more?",
  },
  {
    username: "Cyberpunk 1850",
    avatarUrl:
      "https://static1.colliderimages.com/wordpress/wp-content/uploads/2020/11/cyberpunk-2077-social.jpg",
    timestamp: "Today at 17:42",
    message: "Hey u ready to roll?",
  },
  {
    username: "Imgi",
    avatarUrl: "https://i.imgur.com/cwNLYtg.png",
    timestamp: "Today at 17:42",
    message: "Sup sup sup sup!",
  },
  {
    username: "Brod",
    avatarUrl:
      "https://www.biography.com/.image/c_fill%2Ccs_srgb%2Cfl_progressive%2Ch_400%2Cq_auto:good%2Cw_620/MTY2MzU3Nzk2OTM2MjMwNTkx/elon_musk_royal_society.jpg",
    timestamp: "Today at 17:42",
    message: "Got room for 1 more?",
  },
  {
    username: "Cyberpunk 1850",
    avatarUrl:
      "https://static1.colliderimages.com/wordpress/wp-content/uploads/2020/11/cyberpunk-2077-social.jpg",
    timestamp: "Today at 17:42",
    message: "Hey u ready to roll?",
  },
  {
    username: "Imgi",
    avatarUrl: "https://i.imgur.com/cwNLYtg.png",
    timestamp: "Today at 17:42",
    message: "Sup sup second to last sup sup!",
  },
  {
    username: "Brod",
    avatarUrl:
      "https://www.biography.com/.image/c_fill%2Ccs_srgb%2Cfl_progressive%2Ch_400%2Cq_auto:good%2Cw_620/MTY2MzU3Nzk2OTM2MjMwNTkx/elon_musk_royal_society.jpg",
    timestamp: "Today at 17:42",
    message: "Got room for 1 more?",
  },
]

export default messages
